module.exports = __webpack_public_path__ + "static/media/ic_cancel_start_session.b5939d74.svg";